<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="400">
      <v-card flat>
        <!-- <quick-info-header></quick-info-header> -->
        <!-- <v-card-title class="text-h5"> -->
        <a-toolbar flat light dense color="white">
          <v-toolbar-title>
            <span>{{ getTimeDetails(selectedDate) }}</span>
          </v-toolbar-title>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-toolbar-title v-bind="attrs" v-on="on">
                <span>{{ data.Subject }}</span>
              </v-toolbar-title>
            </template>
            <span>{{ data.Subject }}</span>
          </v-tooltip> -->
          <v-spacer></v-spacer>
          <v-btn class="mr-1" small icon @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </a-toolbar>
        <!-- </v-card-title> -->
        <v-card-text>
        
          <v-row>
            <v-col
              cols="12"
              class="pb-0 pl-0 pr-0"
              v-for="event in events"
              :key="event.id"
            >      
              <v-btn
                x-small                                            
                class="event-button"
                depressed
                @click="onOpenQuickInfo(event)"
                :dark="isDarkTheme(event.meetingType.color)"
                :style="`backgroundColor:${event.meetingType.color}!important;`"
              >
                {{ event.meetingName }}
              </v-btn>
            </v-col>
            <!-- <v-col cols="12">
              <v-btn x-small depressed color="info"> {{event.meetingName}} </v-btn>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Internationalization } from "@syncfusion/ej2-base";
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  name: "MoreEventPopup",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedDate() {
      return this.data.date;
    },
    events() { 
      return this.data.event;
    },
  },
  data() {
    return {
      intl: new Internationalization(),
    };
  },
  methods: {
    onClose,
    getTimeDetails,
    onOpenQuickInfo,
     isDarkTheme(color) {
      return customFunctions.getContrast(color);
    },
  },
};

function onOpenQuickInfo(event) {
  this.$emit("open", event);
  this.$emit("input", false);
}

function getTimeDetails(date) {
  return this.intl.formatDate(date, {
    type: "date",
    skeleton: "long",
  });
}

function onClose() {
  this.$emit("input", false);
}
</script>

<style  scoped>
.event-button {
  width: 100%;
}
::v-deep .v-btn__content {
  justify-content: flex-start !important;
}
</style>